import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { ROUTE_URLS } from '../constants/navigationLinks';

const LogoWrapper = styled(Link)`
  .gatsby-image-wrapper {
    height: var(--height-logo);
  }

  img {
    height: 100%;
    width: auto;
    display: block;
  }
`;

const LogoBanner: React.FC = () => {
  return (
    <LogoWrapper to={ROUTE_URLS.home}>
      <StaticImage
        src="../assets/images/logo_banner.svg"
        alt="Mondmau Developments Banner Logo"
        loading="eager"
        placeholder="none"
        height={60}
      />
    </LogoWrapper>
  );
};

export default LogoBanner;
